export const styles = {
	field: {
		marginBottom: 1,
		width: 400,
		display: 'flex'
	},
	container: {
		padding: 0
	},
	card: {
		display: 'inline-flex',
		flexDirection: 'column',
		marginBottom: 4,
		maxWidth: 900,
		position: 'relative'
	},
	centered: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 2,
		backgroundColor: '#fff'
	}
};
